import axios from "axios";
import Flags from "country-flag-icons/react/3x2";
import { Component, default as React } from "react";
import ContentLoader from "react-content-loader";
import constants from "../../Constants";
import AppDownloadLinks from "../common/AppDownloadLinks";

const baseURL = constants.baseURL;

// Global cache for vehicle types to prevent redundant API calls across components
let vehicleTypesCache = null;
let vehicleTypesCacheTime = 0;
const CACHE_DURATION_MS = 60 * 60 * 1000; // 1 hour cache

class VehiclesBanner extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      openSuccessModal: false,
      truckType: "1.5tonopen",
      apierror: "",
      location: {
        lat: 0,
        lng: 0,
      },
      firstname: "",
      lastname: "",
      email: "",
      mobilenumber: "",
      idnumber: "",
      vin: "",
      licenseplatenumber: "",
      vehicles: 0,
      vehicletypes: [],
    };
  }

  componentDidMount() {
    // Check cache first to avoid redundant API calls
    const now = Date.now();
    if (vehicleTypesCache && (now - vehicleTypesCacheTime) < CACHE_DURATION_MS) {
      this.setState({ vehicletypes: vehicleTypesCache });
      return;
    }

    // Fetch from API and cache the result
    axios.get(baseURL + "/vehicle-types").then((repos) => {
      const vehicletypesdata = repos.data?.vehicles || [];
      vehicleTypesCache = vehicletypesdata;
      vehicleTypesCacheTime = Date.now();
      this.setState({ vehicletypes: vehicletypesdata });
    }).catch((error) => {
      console.error("Failed to fetch vehicle types:", error);
    });
  }

  toggle = () => {
    this.setState({ isOpenMenu: !this.state.isOpenMenu });
  };

  render() {
    const { vehicletypes } = this.state;
    return (
      <>
        {vehicletypes?.length > 0 ? (
          <div
            direction="right"
            className="banner-vehicles"
            speed={35}
            // gradient={false}
          >
            {vehicletypes
              ?.filter((v) => v.sell === true)
              ?.map((vehicle, index) => {
                const image = `https://media.qiktruck.co.za/${vehicle.type}.png`;
                return (
                  <div key={index} className="banner-vehicle">
                    <img src={image} alt="" />
                  </div>
                );
              })}
            <Flags.ZA className="country-flag" /> 
          </div>
        ) : (
          <ContentLoader
            viewBox="0 0 380 70"
            speed={5}
            backgroundColor={"lightgrey"}
            foregroundColor={"#d9ffe3"}
          >
            {/* Only SVG shapes */}
            <rect x="0" y="30" rx="5" ry="5" width="61" height="41" />
            <rect x="80" y="37" rx="4" ry="4" width="200" height="13" />
            <rect x="80" y="60" rx="3" ry="3" width="280" height="10" />
          </ContentLoader>
        )}
        {/* app store download links with the app downloadimage */}
        <AppDownloadLinks showGetQuoteButton={true}/>
      </>
    );
  }
}

export default VehiclesBanner;
